import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const EditCropLink = styled(
  ({ operation, crop, children, farmId, className }) => {
    const { farmId: paramsFarmId } = useParams();
    return (
      <Link
        to={`/app/farm/${farmId || paramsFarmId}/data/crops/${crop.id}${
          operation ? `/operations/${operation.id}` : '/edit'
        }`}
        className={className}
      >
        {children}
      </Link>
    );
  },
)`
  color: var(--text-color);

  &:hover {
    text-decoration: underline;
  }
`;

export default EditCropLink;
